module.exports = {
    continue: 'continue',
    redirect: 'redirect',
    stopNavigation: 'stop-navigation',
};
